/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_External_Sounds_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to use sounds from other servers if they’re a Discord Nitro member." |
*
* @param {Leveling_Perm_Use_External_Sounds_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_external_sounds_hint = /** @type {((inputs?: Leveling_Perm_Use_External_Sounds_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_External_Sounds_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам с подпиской Discord Nitro использовать звуки с других серверов.")
	return /** @type {LocalizedString} */ ("Allows members to use sounds from other servers if they’re a Discord Nitro member.")
});